import { Component, Input, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { ProfileService } from 'src/app/core/services/profile.service';
import { Auction, BiddingService, IBidPoints } from 'src/app/services/bidding.service';
import { CourseCatalogService } from 'src/app/services/course-catalog.service';
import { EnrollmentsService } from 'src/app/services/enrollments.service';
import { ProfileDetailComponent } from '../../people/person/profile-detail.component';
import { BidConfirmModalComponent } from '../bid-confirm-modal/bid-confirm-modal.component';
import { SelectSeatModalComponent } from '../select-seat-modal/select-seat-modal.component';


@Component({
    selector: 'section-list',
    templateUrl: './section-list.component.html',
    styleUrls: ['./section-list.component.scss'],
    standalone: false
})
export class SectionListComponent implements OnDestroy {

    public isAddRunning: any[] = [];
    public isBidRunning: any[] = [];    
    public registration: boolean;
    public bidding: boolean;
    public rounds: any[];
    public auctions: Auction[];
    public auctionbids: IBidPoints;
       
    private destroy$: Subject<boolean> = new Subject<boolean>();
    private _activeAuction: Auction;
   
    @Input() sections: any[];
    @Input() instructors: any[];
    @Input() compareColumn: string;
    @Input() pagename: string;

    constructor(        
        public catalog: CourseCatalogService,
        public enrollmentService: EnrollmentsService,
        public biddingService: BiddingService,
        public profileService: ProfileService,
        public auth: AuthenticationService,
        private modalService: NgbModal      
    ) {
       this.enrollmentService.hasActiveDropAdd$.pipe(takeUntil(this.destroy$)).subscribe(
            (rounds) => {
                if (rounds.some(i => i.active == true)) {
                    this.registration = true;
                } else {
                    this.registration = false;
                }
                this.rounds = rounds;   
            }
        );
        this.biddingService.activeAuctions$.pipe(takeUntil(this.destroy$)).subscribe(
            (auctions) => {
                if (auctions.some(i => i.active == true)) {
                    this.bidding = true;
                } else {
                    this.bidding = false;
                }
                this._activeAuction = auctions.find(a => a.active == true);
                this.auctions = auctions;                
            }
        );
        this.biddingService.auctionBids$.pipe(takeUntil(this.destroy$)).subscribe(
            (auctionBids) => {
                this.auctionbids = auctionBids;                
            }
        );
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();       
    }
        
    public toggleColor(section, favorites) {
              
        var sectionId = section.toString();        
        if (favorites.indexOf(sectionId) > -1) {
            favorites.splice(favorites.indexOf(sectionId), 1);
        } else {
            favorites.push(sectionId);
        }
               
        this.catalog.updateFavorites(favorites);
        
    }
     

    public hasActiveRound(rounds, roundIds, type) {       
        if( type =='add' )
            return roundIds.some(id => rounds[id] && rounds[id].adding);
        else
            return roundIds.some(id => rounds[id] && rounds[id].dropping);
    }

    public checkSeat(section) {
        this.isAddRunning[section.SectionId] = true;

        //  If this is an In-Person/Virtual section with the Virtual option enabled we need to give the students
        //  an opportunity to pick their seat type.
        if (section.SeatChoice) {
            const modalRef = this.modalService.open(SelectSeatModalComponent);
            modalRef.componentInstance.section = section;

            modalRef.result
                .then((res) => {
                    section.SeatAllocation = res;
                    this.add(section);

                })
                .catch(() => this.isAddRunning[section.SectionId] = false);  //  Nothing needs to happen on catch, that just means they closed the modal
        }
        else
            this.add(section);
    }

    private add(section: any) {
        this.enrollmentService.add(section).pipe(takeUntil(this.destroy$)).subscribe((result) => {
            this.isAddRunning[section.SectionId] = false;
            if (result.IsSuccess) {
                section.AllowsAdd = false;
                section.AllowsDrop = result.AllowsDrop;
                section.SeatLabel = result.SeatLabel;
                if (result.ActionTaken == 'Waitlist')
                    section.IsWaitlisted = true;
            }
            this.enrollmentService.openEnrollmentResultModal(result);
        });
    }

    //  Section is shaped differently here than in other places.  Add section.Id so it can use the generic confirmation for drop/abandon.
    private drop(section, buttonType) {
        section.Id = section.SectionId;
        this.enrollmentService.confirmDrop(section, buttonType);
    }
        
    public bid(section) {
        this.isBidRunning[section.SectionId] = true;                
        const modalRefConfirm = this.modalService.open(BidConfirmModalComponent);      
        modalRefConfirm.componentInstance.section = section;       
        modalRefConfirm.componentInstance.auction = this.auctionbids;
        modalRefConfirm.result.then((result) => {
            this.biddingService.add(section.SectionId, this._activeAuction.roundId, result).pipe(takeUntil(this.destroy$)).subscribe((result) => {
                this.isBidRunning[section.SectionId] = false;
                this.enrollmentService.openEnrollmentResultModal(result);
                if (result.BidPoints > 0) {
                    section.PointsBid = result.BidPoints;
                    this.auctionbids.CurrentBidPoints = this.auctionbids.CurrentBidPoints - result.BidPoints;                    
                }
            })            
        },
            () => {               
                this.isBidRunning[section.SectionId] = false;
        });

    }

    public openProfile(openedInstructor) {
        const modalRef = this.modalService.open(ProfileDetailComponent);
        modalRef.componentInstance.person = openedInstructor;
        modalRef.componentInstance.searchterm = "";
    }
}

